<template>
    <div>
      <div class="search_wrap">
        <el-form
          :model="queryParam"
          ref="form"
          label-width="80px"
          :inline="true"
          size="mini"
        >
          <el-form-item label="用户昵称">
            <el-input
              @keyup.enter.native="searchQuery"
              v-model="queryParam.nickName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机">
            <el-input
              @keyup.enter.native="searchQuery"
              v-model="queryParam.phone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
  
          <el-form-item>
            <el-button type="primary" @click="searchQuery">查询</el-button>
            <el-button type="default" @click="searchReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <e-table
        :listLoading="loading"
        :selection="true"
        :tableHeadConfig="columns"
        @pageChange="loadData"
        :paginationData="ipagination"
        :tableLoadData="dataSource"
        @selectLine="onSelectChange"
        :tableRowClassName="tableRowClassName"
      >
      </e-table>
    </div>
  </template>
  
  <script>
  import eTable from "@/components/table";
  import { listMixin } from "@/mixins/listMixin";
  export default {
    name: "deviceList",
    components: { eTable },
    mixins: [listMixin],
    created() {},
    mounted() {
    },
    computed: {},
    watch: {},
    data() {
      return {
        url: {
          list: "/wlCarbonEnergy/queryPage",
        },
        queryParam: {},
        columns: [
          {
            field: "nickName",
            label: "用户昵称",
          },
          {
            field: "phone",
            label: "手机号",
          },
          {
            field: "kitchenCount",
            label: "厨余投递次数",
          },
          {
            field: "totalCarbonEnergyAmount",
            label: "总碳能量",
          },
          {
            field: "usedCarbonEnergyAmount",
            label: "已兑换碳能量",
          },
          {
            field: "availableCarbonEnergyAmount",
            label: "可用碳能量",
          },
        ],
      };
    },
    methods: {
    },
  };
  </script>
  
  <style scoped lang="less">
  .search_wrap {
    margin: 10px 0;
  }
  .selectBox {
    margin-bottom: 18px;
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }
  .selectText {
    width: 80px;
    line-height: 28px;
    font-weight: 700;
    cursor: default;
    float: none;
    display: inline-block;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  </style>
  